import { useEffect, useState } from 'react';
import { useConnectAplautProps } from '../types/TypeProps';
import config from '@app/config';

export const useConnectScriptAplaut = ({ productRN, elementId }: useConnectAplautProps): { isLoaded: boolean } => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  useEffect(() => {
    if (!isLoaded) {
      window._shoppilot = window._shoppilot || [];
      window._shoppilot.push(['_addProductWidget', 'product-reviews', '#' + elementId]);
      window._shoppilot.push(['_setProductId', productRN]);
      window._shoppilot.push(['_addStyles', 'widgets']);

      const storeId = config.aplautStoreId;
      const themeId = 'default';
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = '//get.shoppilot.ru/f/v1/' + storeId + '/' + themeId + '/app.js';
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(script, s);
      script.addEventListener('load', () => setIsLoaded(true));

      return () => {
        script.remove();
        delete window._shoppilot;
        delete window.Shoppilot;
      };
    }
  }, [isLoaded]);

  return { isLoaded };
};
